<template>
    <div class="ui-date-range-picker-candidate ui-picker-date ui-picker-time">
        <!-- * 选择器 -->
        <div class="ui-candidate-modules">
            <!-- * 日期选择器 -->
            <div class="ui-candidate-module">
                <!-- * 日期选择器头部 -->
                <div class="ui-candidates-header">
                    <!-- * 左侧控制器 -->
                    <div class="ui-candidates-controls ui-candidates-left">
                        <!-- * 年份控制器 -->
                        <div class="ui-candidates-control ui-candidates-year" @click="methods.date({ year: date.getFullYear() - 1 })">
                            <UiIcon name="arrow-double" />
                        </div>

                        <!-- * 月份控制器 -->
                        <div class="ui-candidates-control ui-candidates-month" @click="methods.date({ month: date.getMonth() - 1 })">
                            <UiIcon name="arrow" />
                        </div>
                    </div>

                    <!-- * 日期年月信息 -->
                    <div class="ui-candidates-context ui-candidates-selector" @click="$emit('switchover', 'month')">
                        <span>{{ date.getFullYear() }}年</span>
                        <span>{{ date.getMonth() + 1 }}月</span>
                    </div>

                    <!-- * 右侧控制器 -->
                    <div class="ui-candidates-controls ui-candidates-right">
                        <!-- * 月份控制器 -->
                        <div class="ui-candidates-control ui-candidates-month" @click="methods.date({ month: date.getMonth() + 1 })">
                            <UiIcon name="arrow" />
                        </div>

                        <!-- * 年份控制器 -->
                        <div class="ui-candidates-control ui-candidates-year" @click="methods.date({ year: date.getFullYear() + 1 })">
                            <UiIcon name="arrow-double" />
                        </div>
                    </div>
                </div>

                <!-- * 日期选择器内容 -->
                <div class="ui-candidates-date">
                    <div class="ui-candidate-context">一</div>
                    <div class="ui-candidate-context">二</div>
                    <div class="ui-candidate-context">三</div>
                    <div class="ui-candidate-context">四</div>
                    <div class="ui-candidate-context">五</div>
                    <div class="ui-candidate-context">六</div>
                    <div class="ui-candidate-context">日</div>
                    <template v-for="value in days" :key="value.date">
                        <div class="ui-candidate" :class="methods.get_day_status(value)" @click="methods.select({ date: value })">
                            {{ value.day }}
                        </div>
                    </template>
                </div>
            </div>

            <!-- * 时间选择器 -->
            <div class="ui-candidate-module">
                <!-- * 时间选择器头部 -->
                <div class="ui-candidates-header">
                    <div class="ui-candidates-context">{{ cTime }}</div>
                </div>

                <!-- * 时间选择器内容 -->
                <div class="ui-candidates-times">
                    <ui-simplebar class="ui-candidates-time" ref="hourser" :height="300" trigger="Hover">
                        <template v-for="(_, number) in 24">
                            <div class="ui-candidate" :class="{ 'ui-active': cHours == number }" @click="methods.select({ hours: number })">
                                {{ number.toString().padStart(2, "0") }}
                            </div>
                        </template>
                    </ui-simplebar>

                    <ui-simplebar class="ui-candidates-time" ref="minuteser" :height="300" trigger="Hover">
                        <template v-for="(_, number) in 60">
                            <div class="ui-candidate" :class="{ 'ui-active': cMinutes == number }" @click="methods.select({ minutes: number })">
                                {{ number.toString().padStart(2, "0") }}
                            </div>
                        </template>
                    </ui-simplebar>

                    <ui-simplebar class="ui-candidates-time" ref="secondser" :height="300" trigger="Hover">
                        <template v-for="(_, number) in 60">
                            <div class="ui-candidate" :class="{ 'ui-active': cSeconds == number }" @click="methods.select({ seconds: number })">
                                {{ number.toString().padStart(2, "0") }}
                            </div>
                        </template>
                    </ui-simplebar>
                </div>
            </div>
        </div>

        <!-- * 控制器 -->
        <div class="ui-candidates-footer">
            <ui-button size="small" :readonly="finish ? !end : !start" @click="methods.confirm">{{ confirm }}</ui-button>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件引入
import UiIcon from "@various/components/icon";
import UiButton from "@various/components/button";
import UiSimplebar from "@various/components/simplebar";

//* 组件属性
import { ModulePickerEmits } from "../../src/types";
import { useComposable } from "./src/composable";

//* 组件属性注册
defineProps(["confirm"]);
const emits = defineEmits(ModulePickerEmits);

//* 组合函数
const { refs, nodes, methods, computeds } = useComposable(emits);
const { cTime, cHours, cMinutes, cSeconds } = computeds;
const { init, update } = methods;
const { hourser, minuteser, secondser } = nodes;
const { end, date, days, start, finish } = refs;

//* 声明组件配置
defineExpose({ init, update });
</script>
